import React, { createContext, useReducer } from "react";
import { ErrorDialog } from "./ErrorDialog";
import { ErrorReducer, ErrorActionType } from "./ErrorReducer";
import { GeneralExceptionResponse, ValidationExceptionResponse } from "../../../elev/generated/types/error";

export interface GlobalErrorContext {
	state: ErrorState;
	dispatch: React.Dispatch<ErrorActionType>;
}

export interface ErrorState {
	error?: GeneralExceptionResponse | ValidationExceptionResponse;
}

export const initialState: ErrorState = {
	error: undefined
};

export const ErrorContext = createContext<GlobalErrorContext>({} as GlobalErrorContext);

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
export const ErrorStore = ({ children }: any) => {
	const [state, dispatch] = useReducer(ErrorReducer, initialState);

	return (
		<ErrorContext.Provider value={{ state, dispatch }}>
			<ErrorDialog />
			{children}
		</ErrorContext.Provider>
	);
};
